import { render, staticRenderFns } from "./vpd-cookie-banner.vue?vue&type=template&id=0b479282"
import script from "./vpd-cookie-banner.vue?vue&type=script&lang=js"
export * from "./vpd-cookie-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports